// Copied and modified from https://github.com/john-doherty/long-press-event/

import { isPlatform } from "@ionic/core";

if (isPlatform("ios")) {
// This class adds 	-webkit-user-select: none; -webkit-touch-callout: none;
// to the BODY el
    document.body.classList.add('ios13')

    let timer = null

    const clearLongPressTimer = () => {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }

    const cancelEvent = e => {
        e.stopImmediatePropagation();
        e.preventDefault();
        e.stopPropagation();
    }

    const fireLongPressEvent = originalEvent => {

        clearLongPressTimer();

        const el = originalEvent.target
            , x = originalEvent.touches[0].clientX
            , y = originalEvent.touches[0].clientY

        // This will emulate contextmenu mouse event
        const event = new MouseEvent('contextmenu', {
            bubbles: true,
            cancelable: true,
            clientX: x,
            clientY: y
        })


        // fire the long-press event
        const suppressClickEvent = el.dispatchEvent.call(el, event);

        if (suppressClickEvent) {
            // temporarily intercept and clear the next click
            document.addEventListener('touchend', function clearMouseUp(e) {
                document.removeEventListener('touchend', clearMouseUp, true);
                cancelEvent(e);
            }, {once: true});
        }
    }

    const startLongPressTimer = e => {
        clearLongPressTimer(e);
        timer = setTimeout(fireLongPressEvent.bind(null, e), 400);
    }

// hook events that clear a pending long press event
    document.addEventListener('touchcancel', clearLongPressTimer, true);
    document.addEventListener('touchend', clearLongPressTimer, true);
    document.addEventListener('touchmove', clearLongPressTimer, true);

// hook events that can trigger a long press event
    document.addEventListener('touchstart', startLongPressTimer, true); // <- start
}

